import type { ExtensionProps, RicosExtension, RicosExtensionConfig } from 'ricos-types';
import { createRicosFunctionalExtension } from 'wix-rich-content-plugin-commons';

import DraggableHOC from './draggable-HOC';

export const draggable = createRicosFunctionalExtension({
  type: 'extension',
  groups: [],
  name: 'ricos-draggable',
  reconfigure(
    config: RicosExtensionConfig,
    extensions: RicosExtension[],
    _ricosProps: ExtensionProps
  ) {
    const types = extensions
      .filter(extension => extension.groups.includes('draggable'))
      .map(({ name }) => name);

    return {
      ...config,
      priority: 70,
      addNodeHoc: () => {
        return {
          nodeTypes: types,
          nodeHoc: DraggableHOC,
          priority: 70,
        };
      },
    };
  },
  createExtensionConfig() {
    return {
      name: this.name,
    };
  },
});
